import clsx from 'clsx'
import React from 'react'

const PageHeader = ({title, icon, itemsLength, className = '', style = {}, children}) => {
  return (
    <div className={clsx('pageHeader', className)} style={style}>
      <div className="pageTitle">
        <div className="pageTitleIcon">
          {icon}
          <h5>
            {title}&nbsp;
            {![undefined, null].includes(itemsLength) && <span>({itemsLength})</span>}
          </h5>
        </div>
      </div>
      {children}
    </div>
  )
}

export default PageHeader
